$(document).ready(function() {
  $('br').attr('aria-hidden','true');
  $('.h5.tab_a').attr('role', 'tab');
  $('.h5.hide').attr('role', 'tab');
  // for related product slider
  setTimeout(function() {
    $('.col-span-1.splide__slide.col_item[role="tabpanel"]').removeAttr('role');

  }, 2000);

  setInterval(() => {
    $('.splide__pagination__page').attr('aria-selected','false');
    $('.splide__pagination__page.is-active').attr('aria-selected','true');
    $('.collection_tab_slider.active').removeAttr('aria-hidden','true');
    $('.splide__slide ').removeAttr('role','tabpanel');
    $('.Phone').removeAttr('aria-label');

    
  }, 1000);
   
  // Product Page heading Issue from 3rd Party
  setTimeout(function() {
    $('h3.stamped-review-header-title').replaceWith(function() {
      return $('<span>', {
        class: $(this).attr('class'), // Preserve class
        html: $(this).html()         // Keep content
      });
    });
  }, 2000); // 1000ms = 1 second delay
 

});
/// For All Phone Numbers
$(document).ready(function() {
  $('a[href^="tel:"]').each(function() {
    const telNumber = $(this).attr('href').replace('tel:', '');
    const ariaNumber = telNumber.replace(/-/g, '.'); // Replace hyphens with dots
    $(this).attr('aria-label', `Phone Number: ${ariaNumber}`);
  });
});

// List of Email aria label assaigned
$(document).ready(function() {
  // Target ALL email links (any format)
  $('a[href^="mailto:"]').each(function() {
    // Extract email from href
    let email = $(this).attr('href').replace('mailto:', '').trim();
    
    // Clean email (remove query parameters, URL-encoded spaces, etc.)
    email = decodeURIComponent(email) // Handle %20, %40, etc.
            .split('?')[0]           // Remove ?subject=...
            .split('&')[0];           // Remove &body=...
    
    // Set aria-label
    $(this).attr('aria-label', 'Email Address: ' + email);
  });
});

// Social and External link warning Fixed
$(document).ready(function() {
  // Get current hostname (normalized: no 'www.' or protocol)
  const currentHost = window.location.hostname.replace('www.', '');

  // Select all HTTP/HTTPS links (excluding internal links, mailto, tel, and anchors)
  $('a[href^="http://"], a[href^="https://"]').each(function() {
    const $link = $(this);
    const linkHost = this.hostname.replace('www.', '');

    // Skip if link is internal or has no valid host (e.g., #anchor links)
    if (linkHost === currentHost || !linkHost) return;

    // Get link text (trimmed) or fallback to "this link"
    const linkText = $link.text().trim() || 'this link';
    const currentAriaLabel = $link.attr('aria-label');

    // Set aria-label (preserve existing or use link text + warning)
    $link.attr({
      'aria-label': currentAriaLabel 
        ? `${currentAriaLabel} (this link will open in new tab)` 
        : `${linkText} (this link will open in new tab)`,
      'target': '_blank',
      'rel': 'noopener noreferrer'
    });
    $link.attr({
      'title': currentAriaLabel 
        ? `${currentAriaLabel} (this link will open in new tab)` 
        : `${linkText} (this link will open in new tab)`,
      'target': '_blank',
      'rel': 'noopener noreferrer'
    });

    // Optional: Add visual indicator (e.g., ↗)
    $link.addClass('external-link');
  });
});

//Empty Heading issue Fixed
$(document).ready(function() {
  // Remove all empty headings (h1-h6), including those with only <br> tags
  $('h1, h2, h3, h4, h5, h6').each(function() {
    var $heading = $(this);
    // Check if heading is empty or contains only <br> tags (with or without aria-hidden="true")
    if ($.trim($heading.text()).length === 0 && $heading.children('br').length === $heading.children().length) {
      $heading.remove();
    }
  });
});


// For Prices Regular, Sale.
$(document).ready(function () {
  $('.plp_saleprice').each(function () {
    const $salePrice = $(this);
  
    // Check for a <span> with the specific attribute
    const hasCurrencyZero = $salePrice.find('span[doubly-currency-usd="0"]').length > 0;
  
    // Set aria-hidden accordingly
    if (hasCurrencyZero) {
      $salePrice.attr('aria-hidden', 'true');
    } else {
      $salePrice.attr('aria-hidden', 'false');
    }
  });
});
  
// Product Page Tabs
$(document).ready(function() {
  $('.pdp_tabs_links a').first().addClass('active').attr('aria-selected', 'true');

  $('.pdp_tabs_links a').click(function() {
    $('.pdp_tabs_links a').removeClass('active').attr('aria-selected', 'false');
    
    $(this).addClass('active').attr('aria-selected', 'true');
  });
});

$(document).ready(function () {
  $('a.Faq__Question.faq_header').on('click', function () {
    const $button = $(this);
    const expanded = $button.attr('aria-expanded') === 'true';
    $button.attr('aria-expanded', !expanded);
 
    const $content = $button.next();
    $content.prop('hidden', expanded);
  });
});

$(document).ready(function() {
  $('a.external-link .imageforlink img').each(function() {
      // Trim the alt text of the image
      var altText = $(this).attr('alt') || '';
      var trimmedAlt = altText.trim();
      $(this).attr('alt', trimmedAlt);
      
      // Get the parent anchor
      var parentAnchor = $(this).closest('a.external-link');
      
      // Set aria-label on the anchor
      var ariaLabel = trimmedAlt;
      if (ariaLabel) {
          ariaLabel += ', ';
      }
      ariaLabel += 'this link will open in a new tab';
      
      parentAnchor.attr('aria-label', ariaLabel);
      parentAnchor.removeAttr('title');
  });
});

// Function to update aria-hidden attributes
function updateAriaHidden() {
  $('.collection_tab_slider').attr('aria-hidden', 'true');
  $('.collection_tab_slider.active').removeAttr('aria-hidden');
}
updateAriaHidden();
const observer = new MutationObserver(updateAriaHidden);
$('.collection_tab_slider').each(function () {
  observer.observe(this, { attributes: true, attributeFilter: ['class'] });
});

// Home Page Tabs
$(document).ready(function() {
  // On page load, set aria-selected="false" for all tabs
  $('.collection_tab_links .tab_a').attr('aria-selected', 'false');
  
  // Set aria-selected="true" for the active tab
  $('.collection_tab_links .tab_a.active').attr('aria-selected', 'true');

  // When a tab link is clicked
  $('.collection_tab_links .tab_a').on('click', function() {
    // Remove 'active' class and set 'aria-selected' to false for all tab links
    $('.collection_tab_links .tab_a').removeClass('active').attr('aria-selected', 'false');
    
    // Add 'active' class to the clicked tab link and set 'aria-selected' to true
    $(this).addClass('active').attr('aria-selected', 'true');
  });
});

// For the Page Meet the crew
